export type AnalyticsEvent = {
  name: string;
  props?: Record<string, any>;
};

export type Tracker = {
  name: string;
  init: () => void;
  track: (event: AnalyticsEvent) => void;
  teardown?: () => void;
};

class AnalyticsRegistry {
  private trackers: Map<string, Tracker> = new Map();

  register(tracker: Tracker) {
    this.trackers.set(tracker.name, tracker);
    tracker.init();
  }

  track(event: AnalyticsEvent) {
    if (this.trackers.size === 0) {
      console.warn('No trackers registered. Event not sent:', event);
      return;
    }
    this.trackers.forEach(tracker => tracker.track(event));
  }

  teardownAll() {
    this.trackers.forEach(tracker => {
      tracker.teardown?.();
    });
    this.trackers.clear();
  }
}

export const analytics = new AnalyticsRegistry();
